const brown = `#472a0b`;
const sand = `#f2e4cb`;

export default {
  brown,
  sand,
};